import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Select } from "../../atoms/Select";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  allPrefectures: Record<string, string[]>;
  selectablePrefectures: string[];
  handleSubmit: (prefecture: string, city: string) => void;
};

export const SearchStoreByAddressForm: React.FC<Props> = ({
  allPrefectures,
  selectablePrefectures,
  handleSubmit,
}) => {
  const [selectedPrefecture, setSelectedPrefecture] = useState<string>("");

  const schema = useMemo(() => {
    return z.object({
      prefecture: z.string().min(1),
      city: z.string(),
    });
  }, []);

  const prefectureOptions = useMemo(() => {
    return selectablePrefectures.map((prefecture, i) => ({
      id: i + 1,
      name: prefecture,
      value: prefecture,
    }));
  }, [selectablePrefectures]);

  const cityOptions = useMemo(() => {
    return allPrefectures[selectedPrefecture]?.map((city, i) => ({
      id: i + 1,
      name: city,
      value: city,
    }));
  }, [selectedPrefecture]);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    any,
    undefined
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{
        prefecture: "",
        city: "",
      }}
      onSubmit={({ prefecture, city }) => handleSubmit(prefecture, city)}
    >
      <FormContainer>
        <Select
          name="prefecture"
          placeholder="都道府県"
          options={prefectureOptions}
          onChange={(name, value) => {
            setSelectedPrefecture(value);
            methods?.setValue("city", "", { shouldValidate: true });
          }}
        />
        <Select
          name="city"
          placeholder="市区町村"
          options={cityOptions}
          disabled={!selectedPrefecture}
          onChange={() => {}}
        />
      </FormContainer>

      <ButtonContainer>
        <Button type="submit" text="店舗検索" btnStyle="primary" />
      </ButtonContainer>
    </FormTemplate>
  );
};

const FormContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;

const ButtonContainer = styled.div`
  button {
    height: auto;
    padding: 20px 0 18px;
    width: 320px;
    margin: 18px 0 0;
    font-weight: 600;
  }
`;
